import { Box, Button, Circle, Flex, Text } from '@chakra-ui/react';
import { CustomFilterIcon } from '../../theme/icons/CustomFilterIcon';

const FilterButton = ({
  onOpen,
  totalActiveFilters,
}: {
  onOpen: () => void;
  totalActiveFilters: number;
}) => {
  return (
    <Button
      variant="white"
      borderRadius="8px"
      size="sm"
      px={{ base: '15px', sm: '30px' }}
      onClick={onOpen}
      _hover={{ border: '1.5px solid #FF4935' }}
      border={totalActiveFilters ? '1.5px solid' : undefined}
      borderColor={totalActiveFilters ? 'orangePrimary' : undefined}
    >
      <Flex as="span" zIndex={1} alignItems="center">
        {totalActiveFilters ? (
          <Flex as="span" display="inline-block" alignItems="center">
            <Circle
              bg="brand"
              size="18px"
              mr="10px"
              color="white"
              fontSize="11px"
              fontWeight="bold"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box as="span" lineHeight="1" display="block" pt="1px">
                {totalActiveFilters.toString()}
              </Box>
            </Circle>
          </Flex>
        ) : (
          <CustomFilterIcon boxSize="19px" mr="10px" color="orangePrimary" />
        )}
        <Text
          textStyle="bodyFamilyRegular"
          textTransform="none"
          color="#4C4C4C"
          letterSpacing="0.01em"
        >
          Filter
        </Text>
      </Flex>
    </Button>
  );
};

export default FilterButton;
